import { render, staticRenderFns } from "./funding.vue?vue&type=template&id=0a00bc16&scoped=true"
import script from "./funding.vue?vue&type=script&lang=js"
export * from "./funding.vue?vue&type=script&lang=js"
import style0 from "./funding.vue?vue&type=style&index=0&id=0a00bc16&prod&lang=css"
import style1 from "./funding.vue?vue&type=style&index=1&id=0a00bc16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a00bc16",
  null
  
)

export default component.exports